export class SaasClaudeEnterpriseAgentProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "startedByUserId",
            "baseName": "startedByUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstRunAt",
            "baseName": "firstRunAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastRunAt",
            "baseName": "lastRunAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "sessionCount",
            "baseName": "sessionCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasClaudeEnterpriseAgentProperties.attributeTypeMap;
    }
    constructor() {
    }
}
